const areasModel = vm => ({
  title: vm.$gettext('Areas'),
  endpoint: 'areas',
  allowNew: true,
  countrize: 'country',
  fields: [
    {
      key: 'id',
      sortable: true
    },
    {
      key: 'name',
      label: vm.$gettext('Name'),
      sortable: true,
      editable: true,
      required: true
    },
    {
      key: 'country',
      label: vm.$gettext('Country'),
      sortable: true,
      editable: true,
      required: true,
      description: vm.$gettext('Country (2 letter ISO code)')
    },
    {
      key: 'area',
      label: vm.$gettext('Area'),
      editable: false
    },
    {
      key: 'currency',
      label: vm.$gettext('Currency'),
      editable: true,
      required: true,
      description: vm.$gettext('Currency (3 letter ISO code)')
    },
    {
      key: 'symbol',
      label: vm.$gettext('Symbol'),
      editable: true,
      required: true,
      description: vm.$gettext('Currency symbol')
    },
    {
      key: 'locale',
      label: vm.$gettext('Locale'),
      editable: true,
      required: true,
      description: vm.$gettext('Language Locale (ISO 15897 code, ie. es_AR or pt_BR)')
    },
    {
      key: 'is_dangerous',
      label: vm.$gettext('Is Dangerous?'),
      editable: true,
      required: true,
      description: vm.$gettext('Boolean to define if the area is dangerous or not')
    }
  ],
  filters: ['id', 'name', 'country', 'area', 'is_dangerous'],
  includes: ['platform_areas', 'regions'],
  exclude: ['area']
})

export default areasModel
